import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { SubmitButton } from "@/components/auth/AuthLayout";
import { api, errMsg } from "@/lib/api";

const SENT = {
  sms: "If a member account uses that email, a 6-digit code was sent by SMS to the phone number on file. Only one SMS code can be sent per day; if there is no phone on file or today's SMS was already used, the code goes to your email instead.",
  email: "If a member account uses that email, a 6-digit code is on its way to your inbox.",
};

export const ResetCodeForm = ({ email, channel, onBack, onDone }) => {
  const [f, setF] = useState({ code: "", pw: "", pw2: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.pw !== f.pw2) return toast.error("The two passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password-code", { email, code: f.code, new_password: f.pw });
      toast.success("Password changed. You can now sign in with your new password.");
      onDone();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="reset-code-form">
      <p className="text-sm text-gray-600" data-testid="forgot-sent-message">{SENT[channel]} The code works for 30 minutes. Staff accounts get a reset link by email instead.</p>
      <Input value={f.code} onChange={(e) => setF({ ...f, code: e.target.value.replace(/\D/g, "").slice(0, 6) })} inputMode="numeric" placeholder="6-digit code" className="h-11 tracking-[0.4em] text-center text-lg font-bold" required data-testid="reset-code-input" />
      <Input type="password" value={f.pw} onChange={(e) => setF({ ...f, pw: e.target.value })} placeholder="New password" autoComplete="new-password" className="h-11" required data-testid="reset-new-password-input" />
      <Input type="password" value={f.pw2} onChange={(e) => setF({ ...f, pw2: e.target.value })} placeholder="Confirm new password" autoComplete="new-password" className="h-11" required data-testid="reset-confirm-password-input" />
      <SubmitButton busy={busy} testId="reset-code-submit-button">{busy ? "Saving…" : "Reset password"}</SubmitButton>
      <button type="button" onClick={onBack} className="text-sm text-gray-500 hover:text-[#E60000]" data-testid="reset-code-back">Send another code</button>
    </form>
  );
};

const OPTIONS = [["sms", "Reset code by SMS", "to the phone number on file (1 per day)"], ["email", "Reset code by email", "to your email address (unlimited)"]];

export const ChannelPicker = ({ value, onChange }) => (
  <div className="grid gap-2" role="radiogroup" data-testid="reset-channel-picker">
    {OPTIONS.map(([k, label, hint]) => (
      <button type="button" key={k} role="radio" aria-checked={value === k} onClick={() => onChange(k)} data-testid={`reset-channel-${k}`}
        className={`text-left rounded-md border-2 px-3 py-2 transition-colors ${value === k ? "border-[#E60000] bg-[#FFF1F1]" : "border-[#E5E7EB] hover:border-gray-400"}`}>
        <span className="block text-sm font-semibold">{label}</span><span className="block text-xs text-gray-500">{hint}</span>
      </button>
    ))}
  </div>
);
